import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AssignReferralCodeForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAssignReferralCode} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "referralCode");

  return errors.toJS();
}


class AssignReferralCodeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("customerId", this.props.customerId);
    return this.props.assignReferralCode(updatedValues.toJS())
      .then((response) => {
        if (response.data.assignReferralCode.errors.length <= 0) {
          this.props.cancelAssignReferralCode();
        } else {
          let errors = createValidationErrors(response.data.assignReferralCode.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAssignReferralCode();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let codes = fromJS(data.activeReferralCodes);
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        codes={codes}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ASSIGN_REFERRAL_CODE = gql`
  mutation assignReferralCode($data: AssignReferralCodeInput!) {
    assignReferralCode(input: $data) {
      errors { key message }
    }
  }
`;

const ACTIVE_REFERRAL_CODES = gql`
  query activeReferralCodes {
    activeReferralCodes{
      code
    }
  }
`

const withQueries = compose(
  graphql(ACTIVE_REFERRAL_CODES, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(ASSIGN_REFERRAL_CODE, {
    props: ({ mutate }) => ({
      assignReferralCode: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelAssignReferralCode})(withQueries(AssignReferralCodeFormContainer));